import {ActivityVisualTypesEnum} from '../../../src/models/api/activityModel';
import {CommentModel} from '../../../src/models/api/commentModel';
import {getActivities, getComments} from '../../../src/store/data/dataSelectors';
import {getFindTeammate} from '../../../src/store/data/teammates/lazyTeammatesSelectors';
import {AppParametricSelector, createSelector} from '../../helpers/reselectHelpers';

type GetReferencedActivityId<P> = AppParametricSelector<P, number | undefined>;
type GetComment<P> = AppParametricSelector<P, CommentModel | undefined>;

export function makeGetCommentBeingRepliedTo<P>(getReferencedActivityId: GetReferencedActivityId<P>) {
  return createSelector(
    [getActivities, getComments, getReferencedActivityId],
    (activities, comments, referencedActivityId) => {
      if (!referencedActivityId) {
        return undefined;
      }

      const activity = activities[referencedActivityId];
      if (!activity || activity.visualType !== ActivityVisualTypesEnum.COMMENT || !activity.commentUid) {
        return undefined;
      }

      return comments[activity.commentUid];
    },
  );
}

export function makeGetCommentAuthor<P>(getComment: GetComment<P>) {
  return createSelector([getComment, getFindTeammate], (comment, findTeammate) =>
    comment ? findTeammate(comment.authorId, 'referencedActivitySelectors makeGetCommentAuthor') : undefined,
  );
}
